import React, { FunctionComponent } from "react";
import { selectAreaInfo } from "../../../area-info/redux/selectors/select-area-info";
import { useAppSelector } from "../../../system/redux/hooks/redux-store-hooks";

const HOTWCard: FunctionComponent = () => {
	const areaInfo = useAppSelector(selectAreaInfo);
	const handleCoinClick = (e: React.MouseEvent<HTMLButtonElement>) => {
		var videoModal = document.getElementById("hotw-modal");
		const url = new URL(window.location.href);
		url.searchParams.set("homes", "hotw");
		url.searchParams.set("video", "hotw");
		window.history.pushState(null, null, url);

		videoModal.setAttribute("style", "display: block");
		document.body.classList.add("modal-open");
	}

	const handleTileClick = (e: React.MouseEvent<HTMLDivElement>) => {
		var breadcrumbs = document.getElementsByClassName("breadcrumbs")[0];
		// for tablet and mobile
		var tabAnchor = document.getElementsByClassName("tab-anchor")[0];
		breadcrumbs ? breadcrumbs.scrollIntoView({block: 'start', behavior: 'smooth'}) : tabAnchor.scrollIntoView({block: 'start', behavior: 'smooth'});
		document.getElementById("qmiTab").click();
	}

	return (
		<div className="coveo-list-layout CoveoResult" role="listitem">
			<div
					role="link"
					tabIndex={0}
					aria-label="See homes of the week"
					className="hotw-tile-cf"
					onClick={handleTileClick}
				>
				<div className="hotw-banner">
					<div className="coin-container">
							<button aria-label="Watch video about homes of the week" className="hotw-wrapper hotw-tile" onClick={(e) => handleCoinClick(e)}>
								<img className="hotw-coin" src="/-/media/hotw_coin_flat.png" />
								<div className="hotw-coin-shadow"></div>
							</button>
					</div>
					<div className="hotw-banner-descr">
						<h2>Tour our homes of the week in the {areaInfo.Name}{areaInfo.Name?.toLowerCase().endsWith(' area') ? '.' : ' area.'}</h2>
						<span className="btn">Book a tour</span>
					</div>
				</div>
			</div>
		</div>
    );
};

export default HOTWCard;